<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" *ngIf="model === 'undefined'">
  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [clearable]="clearable"
    [readonly]="readonly"
    (change)="onChange($event)"
    [items]="data"
    bindLabel="value"
    [bindValue]="bindValue"
    [loading]="loader"
    [formControlName]="passFormControlName"
    class="colored-select"
    appendTo="body"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
      {{ item.value }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
      <div *ngIf="!item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
  <ng-select
    [clearable]="clearable"
    [readonly]="readonly"
    (change)="onChange($event)"
    [items]="data"
    bindLabel="value"
    [bindValue]="bindValue"
    [loading]="loader"
    [formControlName]="passFormControlName"
    appendTo="body"
    class="colored-select"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
      {{ item.value }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
      <div *ngIf="!item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
    </ng-template>
  </ng-select>
  </ng-template>
</div>

<div *ngIf="model !== 'undefined' || model === undefined">
  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [clearable]="clearable"
    [readonly]="readonly"
    [items]="data"
    bindLabel="value"
    [bindValue]="bindValue"
    [loading]="loader"
    [(ngModel)]="model"
    appendTo="body"
    (change)="changeModel($event)"
    class="type-select colored-select"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
      {{ item.value }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
        {{ item.value }}
      </div>

      <div *ngIf="!item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
  <ng-select
    [clearable]="clearable"
    [readonly]="readonly"
    [items]="data"
    bindLabel="value"
    [bindValue]="bindValue"
    [loading]="loader"
    [(ngModel)]="model"
    (change)="changeModel($event)"
    appendTo="body"
    class="type-select colored-select"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="label-color" [ngStyle]="{ 'background-color': item.color }" *ngIf="item.color"></div>
      {{ item.value }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div [ngStyle]="{ 'background-color': item.color, color: item.invertColor }" *ngIf="item.color" class="item">
        {{ item.value }}
      </div>

      <div *ngIf="!item.color" class="item">
        <span *ngIf="groupType == 'invoice_account' && item?.real_value">{{ item?.real_value }} -</span>
        {{ item.value }}
        <span *ngIf="groupType == 'tax_rates' && item?.real_value">({{ item?.real_value }})</span>
      </div>
    </ng-template>
  </ng-select>
  </ng-template>
</div>
